import { InAppMessagePresentationContext } from "./presentation/InAppMessagePresentationContext"
import { InAppMessagePresentRequest } from "./InAppMessagePresentRequest"

export class InAppMessagePresentResponse {
  constructor(public readonly dispatchId: String, public readonly context: InAppMessagePresentationContext) {}

  /**
   * @override
   */
  toString() {
    return `InAppMessagePresentResponse(dispatchId=${this.dispatchId}, inAppMessage=${this.context.inAppMessage}, displayType=${this.context.message.layout.displayType}, layoutType=${this.context.message.layout.layoutType})`
  }

  static of(
    request: InAppMessagePresentRequest,
    context: InAppMessagePresentationContext
  ): InAppMessagePresentResponse {
    return new InAppMessagePresentResponse(request.dispatchId, context)
  }
}
